import { Navigate } from 'react-router-dom';

/**
 * Route guard — checks token + role before rendering children.
 *   <ProtectedRoute roles={['ROLE_ADMIN','ROLE_SUPERADMIN']}>
 *     <SomePage />
 *   </ProtectedRoute>
 *
 * - No token → redirect to /
 * - Token exists but role not in allowed list → redirect to /
 * - If `roles` is omitted → any authenticated user can access
 */
const ProtectedRoute = ({ roles, children }) => {
  const role = localStorage.getItem('roles');

  if (!role) return <Navigate to="/" replace />;
  if (roles && !roles.includes(role)) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
